export default {
  indicationrewards: [],
  pagination: {},
  indicationreward: {}
}
